// extracted by mini-css-extract-plugin
export default {"backdrop":"Backdrop_backdrop__z-9F6","transparent":"Backdrop_transparent__dUY6J"};